import { createAsyncThunk } from '@reduxjs/toolkit';

import type {
  PorteiroDetalheResposta,
  PorteiroRevisaoPedido,
} from '../../types/porteiroObservabilidade';

import { porteiroAvaliacaoService } from './services';

const mensagemDe = (error: unknown, padrao: string) =>
  error instanceof Error ? error.message : padrao;

export const fetchDetalheDaAvaliacaoDoPorteiro = createAsyncThunk<
  PorteiroDetalheResposta,
  string,
  { rejectValue: string }
>('porteiroAvaliacao/detalhe', async (avaliacaoId, { signal, rejectWithValue }) => {
  try {
    return await porteiroAvaliacaoService.detalhe(avaliacaoId, signal);
  } catch (error) {
    return rejectWithValue(mensagemDe(error, 'Erro ao carregar a trilha da avaliação'));
  }
});

export const revisarEscapeDoPorteiro = createAsyncThunk<
  PorteiroDetalheResposta,
  PorteiroRevisaoPedido,
  { rejectValue: string }
>('porteiroAvaliacao/revisar', async (pedido, { rejectWithValue }) => {
  try {
    return await porteiroAvaliacaoService.revisar(pedido);
  } catch (error) {
    return rejectWithValue(mensagemDe(error, 'Erro ao registrar a revisão da suspeita'));
  }
});
